import localforage from 'localforage'
import axios from 'axios'
import routes from '../../../router'
import store from '../..'

const setCustomerCode = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        'x-access-token': payload.token
      }
    }
    axios.get(`${process.env.URL}/customers/${payload.customer}`, config)
      .then((resultToken) => {
        resolve(resultToken.data.result.code)
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  })
}

const setCustomers = ({ commit }, user) => {
  return new Promise(async (resolve, reject) => {})
}

const setSearchEmail = ({ commit }, user) => {
  return new Promise(async (resolve, reject) => {
    await axios.post(process.env.URL + '/my-clinic-new/auth/search-user', { username: user }, {
      params: {
        customer: 'this.customer'
      }
    }).then((emailUser) => {
      if (emailUser.data.result.length) {
        emailUser.data.result.map((item) => {
          if (item.results.length) {
            resolve(commit('SET_SEARCHEMAIL', item.results))
          }
        })
      }
      // if (emailUser.data.result[0].results.length > 0) {
      //   return resolve(commit('SET_SEARCHEMAIL', emailUser.data.result[0].results))
      // } else {
      //   return routes.push('/auth/sing-up')
      // }
    }).catch((err) => {
      reject(err)
    })
  })
}

const setSearchEmailNew = ({ commit }, user) => {
  commit('SET_SEARCHEMAIL', [])
  return new Promise(async (resolve, reject) => {
    const emailUser = await axios.post(process.env.URL + '/my-clinic-new/auth/search-user-new', { username: user }, {
      params: {
        customer: Math.random().toString(36).slice(2)
      }
    }).catch((err) => {
      return reject(err)
    })

    const userArray = []
    if (emailUser.data.result.length) {
      await Promise.all(emailUser.data.result.map((item) => {
        if (item.results.length) userArray.push(item.results)
      }))

      if (userArray.length) {
        commit('SET_SEARCHEMAIL', userArray)
        return resolve(true)
      } else {
        return resolve(false)
      }
    }
  })
}

const setCreateUser = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    await axios.post(`${process.env.URL}/my-clinic-new/auth/create`, payload, {
      params: {
        customer: 'this.customer'
      }
    }).then((user) => {
      routes.push('/auth/login')
      return resolve(commit('SET_CREATEUSER', user))
    }).catch((err) => {
      return reject(err)
    })
  })
}

const setUpdateSchedule = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    await axios.post(`${process.env.URL}/my-clinic-new/auth/update-schedule`, payload, {
      params: {
        customer: 'this.customer'
      }
    }).then((user) => {
      routes.push('/auth/login')
      return resolve(commit('SET_CREATEUSER', user))
    }).catch((err) => {
      return reject(err)
    })
  })
}

const setLogin = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const { username, password, customer, remeberMe } = payload
    axios.post(`${process.env.URL}/my-clinic-new/auth/login`, {
      username: username,
      password: password
    }, {
      params: {
        customer: customer
      }
    }).then((response) => {
      const getCRM = undefined // await localforage.getItem('my-clinic-crm')
      const customers = []
      response.data.result.auth.map((item) => {
        if (item.myClinic && item.myClinic.length) {
          item.myClinic.map((myClinicItem) => {
            customers.push({
              isLogged: true,
              user: {
                id: item._id,
                username: item.username,
                name: item.name,
                crm: getCRM || myClinicItem.crm,
                customer: myClinicItem.customerId || myClinicItem.customer,
                credentials: btoa(username + ':' + password),
                codeCustomer: myClinicItem.code,
                state: myClinicItem.state || 'PR',
                code: myClinicItem.code,
                customerName: myClinicItem.customerName || myClinicItem.name,
                token: response.data.result.token
              },
              myClinic: {
                code: myClinicItem.code,
                codeCustomer: myClinicItem.code,
                crm: getCRM || myClinicItem.crm,
                customer: myClinicItem.customerId || myClinicItem.customer,
                customerName: myClinicItem.customerName || myClinicItem.name,
                id: item._id,
                name: item.name,
                state: myClinicItem.state || 'PR'
              },
              account: {
                myClinic: item.myClinic
              },
              profile: {
                username: item.username,
                name: item.name
              }
            })
          })
        }
      })
      if (!getCRM) localforage.setItem('my-clinic-crm', customers[0].myClinic.crm)
      commit('SET_TOKEN', response.data.result.token)

      commit('SET_USER', JSON.parse(JSON.stringify(customers[0])))
      commit('SET_CUSTOMERS', customers)

      // store.dispatch('auth/setCustomerCode', auth[0].user).then((resultCustomerCode) => {
      //   console.log('resultCustomerCode', resultCustomerCode)
      //   auth[0].user.codeCustomer = resultCustomerCode
      // })

      // store.dispatch('memed/setToken', auth[0].user).then(() => {
      // }).catch(() => {
      //   store.dispatch('memed/createMemed', auth[0].user)
      // })

      store.dispatch('setCustomer', customers[0].user.customer, {})

      if (remeberMe) {
        localforage.setItem('my-clinic-user', customers[0], (err) => {
          if (err) window.console.error(err)
          localforage.setItem('my-clinic-customer', customers[0].user.customer).then(() => {})
          localforage.setItem('my-clinic-token', response.data.result.token, (err) => {
            if (err) window.console.error(err)
          })
        })
      }
      resolve(routes.push('/schedule'))
    }).catch((err) => {
      window.console.error('errologin', err)
      reject(err)
    })
  })
}

const setSingIn = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const { username, password, customer } = payload
    axios.post(`${process.env.URL}/my-clinic-new/auth/login`, {
      username: username,
      password: password
    }, {
      params: {
        customer: customer
      }
    }).then((response) => {
      const auth = response.data.result.auth.map((item) => {
        return {
          isLogged: true,
          user: {
            id: item._id,
            username: item.username,
            name: item.name,
            crm: item.myClinic[0].crm,
            customer: item.myClinic[0].customerId || item.myClinic[0].customer,
            credentials: btoa(username + ':' + password),
            codeCustomer: item.myClinic[0].code,
            state: item.myClinic[0].state || 'PR',
            code: item.myClinic[0].code,
            customerName: item.myClinic[0].customerName || item.myClinic[0].name
          },
          myClinic: {
            code: item.myClinic[0].code,
            codeCustomer: item.myClinic[0].code,
            crm: item.myClinic[0].crm,
            customer: item.myClinic[0].customerId || item.myClinic[0].customer,
            customerName: item.myClinic[0].customerName || item.myClinic[0].name,
            id: item._id,
            name: item.name,
            state: item.myClinic[0].state || 'PR'
          },
          profile: {}
        }
      })
      commit('SET_TOKEN', response.data.result.token)
      commit('SET_USER', auth[0])
      commit('SET_CUSTOMERS', auth)
      store.dispatch('setCustomer', auth[0].user.customer, {})
      resolve(routes.push('/schedule'))
    }).catch((err) => {
      window.console.error('errologin', err)
      reject(err)
    })
  })
}

const setSingOut = ({ commit }, user) => {
  const auth = {
    isLogged: false,
    user: {
      id: null,
      username: null,
      name: null,
      crm: null,
      customer: null
    },
    profile: {}
  }
  commit('SET_TOKEN', null)
  commit('SET_USER', auth)
  localforage.removeItem('my-clinic-customer')
  localforage.removeItem('my-clinic-token')
  localforage.removeItem('my-clinic-user')
}

const setUser = ({ commit }, user) => {
  commit('SET_USER', user)
}

const setRegister = ({ commit }, user) => {
  commit('SET_REGISTER', user)
}

const setToken = ({ commit }, token) => {
  commit('SET_TOKEN', token)
}

const setRecoveryPassword = ({ commit }, token) => {
  commit('SET_RECOVERY_PASSWORD', token)
}

const setChangeSchedule = ({ commit }, payload) => {
  commit('SET_CHANGE_SCHEDULE', payload)
}

export default {
  setUser,
  setToken,
  setLogin,
  setRecoveryPassword,
  setSingOut,
  setSearchEmail,
  setCreateUser,
  setUpdateSchedule,
  setRegister,
  setSingIn,
  setCustomers,
  setCustomerCode,
  setChangeSchedule,
  setSearchEmailNew
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js